import COM from './Media'

export default COM
